import { Config } from './index';

const config: Config = {
  calculationApiUrl: 'https://staging-api.b2tech.com/api/v1/calculate',
  debug: false,
  version: '0.0.1',
  environment: 'staging'
};

export default config;